const CONFIG = {
    'app_name': 'RIA-TECHNICAL-TEST',
    'uri_api': 'https://api.exchangeratesapi.io',
    'base_currency': 'EUR',
  }
  
  export default CONFIG